import {withNamespaces} from "react-i18next";
import React, {useState} from "react";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";
import todayIcon from "../../assets/images/mgsuite/fullday.png";
import yesterdayIcon from "../../assets/images/mgsuite/fullday.png";
import thisWeekIcon from "../../assets/images/mgsuite/fullweek.png";
import lastWeekIcon from "../../assets/images/mgsuite/fullweek.png";
import thisMonthIcon from "../../assets/images/mgsuite/fullmonth.png";
import lastMonthIcon from "../../assets/images/mgsuite/fullmonth.png";
import lastYearIcon from "../../assets/images/mgsuite/fullyear.png";
import moment from "moment/moment";
import {DateTimePicker} from "react-widgets";

const SettingsPanelDateTimeSpanSelector = ({translation, fromDateChanged, tillDateChanged, sendButtonClicked}) => {
    const defaultTimeSpanOptions = [
        {
            value: "today",
            label: (
                <div className="flex-iac settings-item">
                    <img src={todayIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.heute")}/>{" "}
                    {translation("allgemein.zeitraumfilter.heute")}
                </div>
            ),
        },
        {
            value: "yesterday",
            label: (
                <div className="flex-iac settings-item">
                    <img src={yesterdayIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.gestern")} />{" "}
                    {translation("allgemein.zeitraumfilter.gestern")}
                </div>
            ),
        },
        {
            value: "thisweek",
            label: (
                <div className="flex-iac settings-item">
                    <img src={thisWeekIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.dieseWoche")} />{" "}
                    {translation("allgemein.zeitraumfilter.dieseWoche")}
                </div>
            ),
        },
        {
            value: "lastweek",
            label: (
                <div className="flex-iac settings-item">
                    <img src={lastWeekIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.letzteWoche")} />{" "}
                    {translation("allgemein.zeitraumfilter.letzteWoche")}
                </div>
            ),
        },
        {
            value: "thismonth",
            label: (
                <div className="flex-iac settings-item">
                    <img src={thisMonthIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.diesenMonat")} />{" "}
                    {translation("allgemein.zeitraumfilter.diesenMonat")}
                </div>
            ),
        },
        {
            value: "lastmonth",
            label: (
                <div className="flex-iac settings-item">
                    <img src={lastMonthIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.letztenMonat")} />{" "}
                    {translation("allgemein.zeitraumfilter.letztenMonat")}
                </div>
            ),
        },
        {
            value: "custom",
            label: (
                <div className="flex-iac settings-item">
                    <img src={lastYearIcon} className="select-icon" alt={translation("allgemein.zeitraumfilter.sonstige")} />{" "}
                    {translation("allgemein.zeitraumfilter.sonstige")}
                </div>
            ),
        },
    ];
    const customTimeSpanOption = defaultTimeSpanOptions[defaultTimeSpanOptions.length-1];
    const [selectedDefaultTimespanOption, setSelectedDefaultTimespanOption] = useState(defaultTimeSpanOptions[0]);

    const now = new Date();
    const [selectedFromDateTime, setSelectedFromDateTime] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0));
    const [selectedTillDateTime, setSelectedTillDateTime] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59));
    
    // TODO: Add Options to restrict TimeSpan to <>= Today.
    // Currently not used by me, and the momentjs parsing thing from like Events.js does not look right to me.
    // at least it also don't support english DateTime Formats.
    
    // TODO: DateTimePicker "Today" label is not i18n. Seems to be a custom module?

    function setTimesFromOptionValue(selection) {
        let newFromDateMoment, newTillDateMoment;
        switch (selection) {
            case "today":
                newFromDateMoment = moment();
                newTillDateMoment = moment();
                break;
            case "yesterday":
                newFromDateMoment = moment().subtract(1, "days");
                newTillDateMoment = moment().subtract(1, "days");
                break;
            case "thisweek":
                newFromDateMoment = moment().startOf("week");
                newTillDateMoment = moment();
                break;
            case "lastweek":
                newFromDateMoment = moment().subtract(1, "weeks").startOf("week");
                newTillDateMoment = moment().subtract(1, "weeks").endOf("week");
                break;
            case "thismonth":
                newFromDateMoment = moment().startOf("month");
                newTillDateMoment = moment();
                break;
            case "lastmonth":
                newFromDateMoment = moment().subtract(1, "months").startOf("month");
                newTillDateMoment = moment().subtract(1, "months").endOf("month");
                break;
            default:
                return;
        }
        
        newFromDateMoment.set({hour:0,minute:0,second:0,millisecond:0});
        newTillDateMoment.set({hour:23,minute:59,second:59,millisecond:0});

        let newFromDate = new Date(newFromDateMoment);
        let newTillDate = new Date(newTillDateMoment);
        
        setSelectedFromDateTime(newFromDate);
        setSelectedTillDateTime(newTillDate);

        fromDateChanged?.(newFromDate);
        tillDateChanged?.(newTillDate);
    }

    return (
        <div className="content-group" style={{width: '100%'}}>
            <div className="content-group-name">
                {translation("allgemein.zeitraum")}
            </div>

            <div>
                <Select
                    styles={customStyles}
                    isSearchable={false}
                    value={selectedDefaultTimespanOption}
                    onChange={(selection) => {
                        setSelectedDefaultTimespanOption(selection);
                        setTimesFromOptionValue(selection.value);
                    }}
                    options={defaultTimeSpanOptions}
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 3,
                        colors: {
                            ...theme.colors,
                            primary: "#20a0ff",
                        },
                    })}
                />
            </div>

            <div style={{padding: "5px"}}>{translation("allgemein.von")}</div>
            <DateTimePicker
                includeTime
                parse={(str) => moment(str, "DD/MM/YYYY HH:mm").toDate()}
                style={{ width: "100%" }}
                className="datetime-picker"
                value={selectedFromDateTime}
                onChange={(date) => {
                    setSelectedFromDateTime(date);
                    setSelectedDefaultTimespanOption(customTimeSpanOption);
                    fromDateChanged?.(date);
                }}
            />

            <div style={{padding: "5px"}}>{translation("allgemein.bis")}</div>
            <DateTimePicker
                includeTime
                parse={(str) => moment(str, "DD/MM/YYYY HH:mm").toDate()}
                style={{ width: "100%" }}
                className="datetime-picker"
                value={selectedTillDateTime}
                min={selectedFromDateTime}
                onChange={(date) => {
                    setSelectedTillDateTime(date);
                    setSelectedDefaultTimespanOption(customTimeSpanOption);
                    tillDateChanged?.(date);
                }}
            />

            {typeof sendButtonClicked === "function" &&
                <button 
                    className={"button"} style={{ marginTop: "10px", marginBottom: "10px" }}
                    onClick={()=> sendButtonClicked(selectedFromDateTime, selectedTillDateTime)}
                >
                    {translation("allgemein.senden")}
                </button>
            }
        </div>
    );
}

export default withNamespaces()(SettingsPanelDateTimeSpanSelector);
